import { Link } from 'react-router';
import { FramedImage } from '@/components/FramedImage';
import { useI18n } from '@/client/i18n/I18nContext';
import { COLORIMETRY_PATH, COLORIMETRY_TITLE, FACE_PATH, SILHOUETTE_PATH } from '@/lib/colorimetry/route';
import { gameCard, styleCard } from '@/lib/colorimetry/promo';
import type { GameId } from '@/lib/colorimetry/landing';
import { lp } from '@/client/i18n/locale';

// Same map as GAME_LANDING_PATH (lib/colorimetry/landing), repeated from route.ts on purpose: importing
// landing.ts would bring landing.json into the bundles of /caro/servicios and the Edit.
const GAME_PATHS: Readonly<Record<GameId, string>> = { colorimetry: COLORIMETRY_PATH, silhouette: SILHOUETTE_PATH, face: FACE_PATH };

/**
 * A style test: its card, linked to the game. COLORIMETRY ME! on /caro/servicios; any of the three at
 * the end of the Edit articles that ask for it (`endLinks: ['colorimetry' | 'silhouette' | 'face']`).
 * Prerender: gamePromoHtml.
 */
export function GamePromo({ game }: { game: GameId }) {
  const { t, locale } = useI18n();
  const card = game === 'colorimetry' ? gameCard(locale) : styleCard(game, locale);
  const path = lp(GAME_PATHS[game]);
  const title = game === 'colorimetry' ? COLORIMETRY_TITLE : t(`services.${game}.title`);
  const titleId = `${game}-promo-title`;
  return (
    <section className="pdp" style={{ alignItems: 'center', paddingBottom: 'var(--space-6)' }} aria-labelledby={titleId}>
      {card ? (
        <Link to={path} className="casa-card__media" style={{ aspectRatio: '1200 / 630' }} tabIndex={-1} aria-hidden>
          <FramedImage src={card} alt={t(`services.${game}.imageAlt`)} fallback={title} />
        </Link>
      ) : null}
      <div className="stack" style={{ maxWidth: 'var(--width-text)' }}>
        <p className="eyebrow">{t(`services.${game}.eyebrow`)}</p>
        <h2 id={titleId} style={{ margin: 0 }}>{title}</h2>
        <p>{t(`services.${game}.text`)}</p>
        <div>
          <Link className="btn" to={path}>{t(`services.${game}.cta`)}</Link>
        </div>
      </div>
    </section>
  );
}
